import React from 'react';
import styled from 'styled-components';

const anatomyData = [
  { id: 1, block: 'Role & Context', includes: [
    'Who the AI should "be" (lawyer, tutor, marketer)',
    'Any domain expertise or point‑of‑view',
    'Brief background of the task',
  ] },
  { id: 2, block: 'Task / Request', includes: [
    'Clear action: "draft", "compare", "debug"',
    'Constraints (tone, length, date range)',
    'Success criteria ("bullet list", "≤ 200 words")',
  ] },
  { id: 3, block: 'Input Data', includes: [
    'Facts, URLs, or text snippets',
    'File uploads (PDF, CSV) or examples',
  ] },
  { id: 4, block: 'Output & Style', includes: [
    'Preferred format (table, JSON, code)',
    'Tone or persona guidelines',
    'Any token / word limits',
  ] },
  { id: 5, block: 'Additional Parameters', includes: [
    'Temperature / creativity level (if UI exposes it)',
    'Anything else the model should avoid (jargon, region‑specific units)',
  ] },
];

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 0.5rem;
  margin-bottom: 1.5rem;
`;
const Th = styled.th`
  text-align: left;
  font-weight: 600;
  padding: 0.5rem 1rem;
  background: #f6f8fa;
  color: #1a237e;
`;
const Td = styled.td`
  background: #fff;
  padding: 1rem;
  border-radius: 8px;
  vertical-align: top;
  font-size: 1rem;
`;
const NumberCircle = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #1976d2;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.1rem;
  margin-right: 0.5rem;
`;
const Callout = styled.div`
  background: #e3f2fd;
  border-left: 4px solid #1976d2;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-top: 1.5rem;
`;
const CalloutIcon = styled.span`
  font-size: 1.5rem;
  color: #1976d2;
  margin-top: 0.1em;
`;

const IdealPromptAnatomy = () => (
  <div>
    <h2 style={{ textAlign: 'center', color: 'var(--primary-color)', fontSize: '1.8rem', fontWeight: 700, marginBottom: '0.5rem' }}>
      Ideal Prompt Anatomy
    </h2>
    <Table>
      <thead>
        <tr>
          <Th>#</Th>
          <Th>Block</Th>
          <Th>What to include</Th>
        </tr>
      </thead>
      <tbody>
        {anatomyData.map(row => (
          <tr key={row.id}>
            <Td><NumberCircle>{row.id}</NumberCircle></Td>
            <Td style={{fontWeight: 600}}>{row.block}</Td>
            <Td>
              <ul style={{margin: 0, paddingLeft: '1.2em'}}>
                {row.includes.map((inc, i) => <li key={i}>{inc}</li>)}
              </ul>
            </Td>
          </tr>
        ))}
      </tbody>
    </Table>
    <Callout>
      <CalloutIcon>💡</CalloutIcon>
      <div>
        <strong>Why this matters:</strong> Models reward specificity. Defining role + task + data + output up front can cut iterations by up to 50%.
      </div>
    </Callout>
  </div>
);

export default IdealPromptAnatomy; 